import { createBrowserRouter } from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import Layout from "./Pages/Layout";
import Tenants from "./Pages/Tenants";
import TenantUsers from "./Pages/TenantUser";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        children: [
            {
                path: '',
                element: <Dashboard />
            },
            {
                path: 'tenants',
                element: <Tenants />
            },
            {

                path: 'tenant-users',
                element: <TenantUsers />
            }
        ]
    }
])

export default router